<script setup>
import { computed, onBeforeMount,  onUnmounted } from 'vue'
import FilterBar from '@src/modules/analytics/views/overviewV2/components/FilterBar.vue';
import useAnalyticsUtils from '@src/modules/analytics/components/common/composables/useAnalyticsUtils.js'
import useOverviewAnalytics from '@src/modules/analytics/views/overviewV2/composables/useOverviewAnalytics.js'
import TabsComponent from '@src/modules/analytics/views/common/TabsComponent.vue'
import OverviewSection from '@src/modules/analytics/views/overviewV2/components/OverviewSection.vue'
import CstAlert from '@ui/Alert/CstAlert'
import { useStore } from '@state/base'
import { EventBus } from '@common/lib/event-bus'


const { selectAllAccounts } = useAnalyticsUtils()
const {
  IGNORE_PLATFORMS,
  selectedAccount
} = useOverviewAnalytics()

const { getters } = useStore()

onBeforeMount(() => {
  EventBus.$on('workspace-changed', () => {
    console.log('workspace changed')
  })
})

onUnmounted(() => {
  console.log('unmounted')
  EventBus.$off('workspace-changed')
})

const getAllAccounts = computed(() => {
  return selectAllAccounts(IGNORE_PLATFORMS)
})

const isReconnectRequired = computed(() => {
  return selectedAccount && selectedAccount.value && selectedAccount.value.some(account => ['invalid','expired'].includes(account.validity))
})

const invalidAccounts = computed(() => {
  return selectedAccount.value.filter(account => ['invalid','expired'].includes(account.validity))
})

const ScrollToTop = () => {
  setTimeout(() => {
    mainComponentRef.value?.scrollIntoView({ behavior: 'smooth' })
  }, 0)
}

</script>

<template>
  <div ref="mainComponentRef" class="analytics-main-container">
    <FilterBar @scroll-to-top="ScrollToTop"/>
    <div
      v-if="!getAllAccounts.length "
      class="analytics-main-errors"
    >
      <img
        alt="No accounts connected"
        draggable="false"
        src="@modules/analytics/assets/imgs/no_data_images/no-account-connected.svg"
      />
      <p>
        <span > No Account(s) Connected </span>
        <small>Connect a social account </small>
        <router-link
          class="btn btn-studio-theme-space btn-size-small"
          :to="{
            path: `/${getters.getActiveWorkspace.slug}/settings/social`,
          }"
          >Connect Accounts
        </router-link>
      </p>
    </div>
    <div v-else>
      <TabsComponent :tabs="['#overview']" type="overview">
        <template v-if="isReconnectRequired" v-slot:alert>
            <CstAlert v-if="invalidAccounts.length > 1" type="warn" class="text-left mb-5">
              Access tokens for some of your social accounts have expired. Reconnect them to view updated data.
              <router-link
                class=" text-yellow-600 font-semibold hover:text-yellow-700"
                :to="{ name: 'social', params: { id: invalidAccounts[0].account_type }  }"
                >Reconnect Now
              </router-link>
            </CstAlert>
            <CstAlert v-else type="warn" class="text-left mb-5">
              Access token for your <span class="capitalize">{{ invalidAccounts[0].account_type }}</span> account {{ invalidAccounts[0].name }} has expired. Reconnect it to view updated data.
              <router-link
                class=" text-yellow-600 font-semibold hover:text-yellow-700"
                :to="{ name: 'social', params: { id: invalidAccounts[0].account_type }  }"
                >Reconnect Now
              </router-link>
            </CstAlert>
          </template>
        <!-- overview tab -->
        <template v-slot:overview>
          <OverviewSection />
        </template>
      </TabsComponent>
    </div>

  </div>
</template>
